export enum DisplayComponent {
  FindOutMore = "find-out-more",
  SignUpNewsletter = "sign-up-newsletter",
  SignUpSuccessMessage = "sign-up-success-message",
}

export enum Variant {
  AcquisitionNewsletterPopup = "acquisition-newsletter-popup",
  Article = "article",
  Article20 = "article20",
  ArticleDark = "article-dark",
  Footer = "footer",
  Homepage = "homepage",
  LiveArticle = "live-article",
  NewsletterArticle = "newsletter-article",
  NewsletterArticleBottom = "newsletter-article-bottom",
  NewsletterList = "newsletter-list",
  NewsletterPreview = "newsletter-preview",
  Posties = "posties",
  Section = "section",
}
